import { render, staticRenderFns } from "./GenomesPie.vue?vue&type=template&id=52f3c558&"
import script from "./GenomesPie.vue?vue&type=script&lang=js&"
export * from "./GenomesPie.vue?vue&type=script&lang=js&"
import style0 from "./GenomesPie.vue?vue&type=style&index=0&id=52f3c558&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports